export const ROUTE_HOME = "/"
export const ROUTE_HOME_TOP = "top"
export const ROUTE_SECTION_KNOW_US = "knowus"
export const ROUTE_SECTION_TEAM = "team"
export const ROUTE_SECTION_PARTNERS = "partners"
export const ROUTE_SECTION_COLLABORATION = "collaboration"
export const ROUTE_SECTION_PROCESS = "process"
export const ROUTE_SECTION_CONTACT = "contact"

export const ROUTE_PRODUCTS = "/products"

export const ROUTE_BIONANOAXUS_PRODUCT_PAGE = "/products/bionanoaxus"
export const ROUTE_ZCLEAN_PRODUCT_PAGE = "/products/z-klean"

export const ROUTE_PATENT_PAGE = "/technology/patent"
